export default __webpack_public_path__ + "static/media/8.a9df902f.jpg";